import AppShell from "@/components/AppShell";
import { Card, CardContent } from "@/components/ui/card";

export default function About() {
  return (
    <AppShell>
      <div className="max-w-3xl mx-auto px-6 py-12 space-y-6" data-testid="about-page">
        <div>
          <div className="text-xs uppercase tracking-[0.16em] text-[#0066ff] font-bold mb-2">About</div>
          <h1 className="text-4xl font-semibold tracking-tight text-slate-900">OPSTR<span className="text-[#0066ff]">AI</span></h1>
          <p className="text-lg text-slate-600 mt-2">Strata operations, powered by AI.</p>
        </div>
        <Card>
          <CardContent className="py-6 space-y-4 text-sm text-slate-700 leading-relaxed">
            <p>Opstrait is an AI co-pilot for self-managed strata committees in Australia (NSW + QLD). It brings compliance tracking, meeting workflows, owner communications, insurance command, and billing into one place — with Claude grounded in the state's actual strata legislation behind every assistive feature.</p>
            <p>Designed for chairs, committee members, and lot owners — small enough teams that hiring a full-time strata manager doesn't pencil out, but big enough that the paperwork can absorb a full weekend a month.</p>
            <p className="text-xs text-slate-500 pt-3 border-t border-slate-100">
              All AI outputs include general-information-only disclaimers. Opstrait does not provide legal or financial advice.
            </p>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
